import Vue from 'vue'
import Router from 'vue-router'
import BulkEncounters from './views/BulkEncounters.vue'
import EncounterEdit from './views/EncounterEdit.vue'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import PatientEdit from './views/PatientEdit.vue'
import PatientOverview from './views/PatientOverview.vue'
import EyeEncounterEdit from './views/EyeEncounterEdit.vue'
import SurveyReport from './views/SurveyReport.vue'
import SurveyResponse from './views/SurveyResponse.vue'
import UatCapture from './views/UatCapture.vue'

Vue.use(Router)

const orgInitCheck = function (to, from, next) {
  if (!to.params.orgName) next('/about')
  else {
    next()
    // if (!store.state.init.status.populated) {
    //   this.$store.dispatch('init/populate', '').then(
    //     () => {
    //       next()
    //     },
    //     error => {
    //       console.error(error)
    //     }
    //   )
    // }
  }
}

//
// NOTE: ALL ROUTES NEED to accept the orgName URL param because App.Vue expects it
//

export default new Router({
  routes: [
    { path: '/:orgName/home', name: 'home', component: Home, beforeEnter: orgInitCheck },
    { path: '/:orgName/', name: 'Login', component: Login },
    {
      path: '/:orgName/encounters/bulk',
      name: 'bulk-encounters',
      component: BulkEncounters
    },
    {
      path: '/:patientId/encounter/:encounterId/edit',
      name: 'eye-encounter-edit',
      component: EyeEncounterEdit
    },
    {
      path: '/:orgName/:patientId/encounter/:encounterId/edit',
      name: 'encounter-edit',
      component: EncounterEdit
    },
    {
      path: '/:orgName/:patientId/encounter/:encounterId/survey/:surveyId/report',
      name: 'survey-report',
      component: SurveyReport
    },
    {
      path: '/:orgName/:patientId/encounter/:encounterId/survey/:responseId',
      name: 'survey-response',
      component: SurveyResponse
    },
    {
      path: '/:orgName/patient/:patientId/edit',
      name: 'patient-edit',
      component: PatientEdit
    },
    {
      path: '/:orgName/patient/:patientId',
      name: 'patient-overview',
      component: PatientOverview
    },
    {
      path: '/:orgName/demo/uat',
      name: 'uat',
      component: UatCapture
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/:orgName/editor/encounter-templates',
      name: 'encounterTemplates',
      component: () => import(/* webpackChunkName: "about" */ './views/EncounterTemplates.vue')
    }
  ]
})
